import estandartePng from "../assets/estandarte.png";

export function EstandarteSection() {
  return (
    <div id="estandarte" className="page-section flex flex-col grow bg-white">
      <section className="bg-white pt-nav pb-24 border-t border-gray-100 grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 text-center">
          <i className="fa-solid fa-flag text-5xl text-dourado mb-4"></i>
          <h2 className="text-sm text-dourado font-bold tracking-widest uppercase mb-2">
            Simbologia e Identidade
          </h2>
          <h3 className="text-4xl sm:text-5xl font-titulo font-bold text-petroleo mb-16">
            O Nosso Estandarte
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 text-left items-start">
            {/* Imagem/Representação Visual */}
            <div className="lg:col-span-5 flex justify-center">
              <div className="relative shadow-2xl rounded-2xl overflow-hidden border-4 border-dourado bg-petroleo p-1 w-full max-w-[380px]">
                <img
                  src={estandartePng}
                  alt="Estandarte Loja Hórus 147"
                  className="w-full h-auto object-contain rounded-xl"
                />
              </div>
            </div>

            {/* Explicação dos Símbolos */}
            <div className="lg:col-span-7 space-y-8">
              <div>
                <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-6 text-justify">
                  O Estandarte da A.·.R.·.L.·.S.·. Hórus Nº 147 é a expressão
                  visual dos princípios e virtudes que norteiam os nossos
                  irmãos, traduzindo o ideal maçônico de aperfeiçoamento e
                  construção de uma sociedade justa.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* As Cores */}
                <div className="bg-fundo p-6 rounded-xl border border-gray-100 shadow-sm">
                  <h4 className="font-titulo text-xl text-petroleo font-bold mb-4 border-b border-dourado pb-2">
                    O Significado das Cores
                  </h4>
                  <ul className="space-y-4 text-sm sm:text-base">
                    <li>
                      <strong className="text-petroleo">
                        Azul Marinho / Petróleo:
                      </strong>{" "}
                      Representa a universalidade do espírito maçônico e a
                      abóbada celeste. Simboliza o infinito, a tolerância, a
                      estababilidade e a força.
                    </li>
                    <li>
                      <strong className="text-dourado">Dourado (Ouro):</strong>{" "}
                      Reflete a luz espiritual, a iluminação e a sabedoria.
                      Simboliza a nobreza dos ideais e a busca contínua pela
                      perfeição.
                    </li>
                  </ul>
                </div>

                {/* Os Símbolos */}
                <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm">
                  <h4 className="font-titulo text-xl text-petroleo font-bold mb-4 border-b border-dourado pb-2">
                    A Simbologia Sagrada
                  </h4>
                  <ul className="space-y-4 text-sm sm:text-base">
                    <li>
                      <strong className="text-petroleo">
                        Esquadro e Compasso:
                      </strong>{" "}
                      O equilíbrio perfeito entre a matéria (retidão e justiça)
                      e o espírito (moderação das paixões).
                    </li>
                    <li>
                      <strong className="text-petroleo">
                        O Olho de Hórus:
                      </strong>{" "}
                      A onipresença que convida o iniciado à vigilância interior
                      e à pureza de intenções.
                    </li>
                    <li>
                      <strong className="text-petroleo">
                        Colunas, Sol e Lua:
                      </strong>{" "}
                      A força, a estabilidade e a dualidade da iluminação que
                      irradia sobre o nosso trabalho.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default EstandarteSection;
